import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ErrorLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: ErrorLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'error-log-list-grid-action-cell',
    template:
        `@if (errorLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class ErrorLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ErrorLogListGridActionCellRendererParams;
    errorLog: Core.ErrorLogModel;

    agInit(params: ErrorLogListGridActionCellRendererParams): void {
        this.params = params;
        this.errorLog = params.data as Core.ErrorLogModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
